/**
 * Composition methods for the endpoint view
 * 
 * Author: Andrea López <andrea.lopez@huumun.com>
 */
import { useRouter } from 'vue-router';

export function endpointNavigationComposition () {
    const router = useRouter();

    /**
     * Navigate function
     */
    function navigateTo (path: string) {
        router.push(path);
    }

    return { navigateTo }
}
